import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import PhoneInput from '../../components/PhoneInput/PhoneInput';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import { createEmptyPhoneModel, toPhonePayload } from '../../utils/phoneCountries';
import styles from './loginpage.module.css';

function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const telefoneInputRef = useRef(null);
  const [telefone, setTelefone] = useState(() => createEmptyPhoneModel());
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [telefoneErro, setTelefoneErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErro('');
    setTelefoneErro('');

    if (!telefone.isValid) {
      const message = 'Telefone inválido para o país informado.';
      setTelefoneErro(message);
      showToast(message, 3000, 'error');
      return;
    }

    setCarregando(true);
    try {
      const result = await login({ ...toPhonePayload('telefone', telefone), senha });
      if (result.success) {
        showToast('Login realizado com sucesso!', 3000, 'success');
        navigate('/home');
        return;
      }

      const message = result.status === 401
        ? 'Telefone ou senha inválidos'
        : (result.message || 'Falha no login');
      setErro(message);
      showToast(message, 3000, 'error');
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) navigate('/home');
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    telefoneInputRef.current?.focus();
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Login</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <PhoneInput
          ref={telefoneInputRef}
          value={telefone}
          onChange={setTelefone}
          label="Telefone"
          error={telefoneErro}
          disabled={carregando}
          required
        />
        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={(event) => setSenha(event.target.value)}
          className={styles.input}
          required
        />
        <button type="submit" className={styles.button} disabled={carregando}>
          {carregando ? 'Entrando...' : 'Entrar'}
        </button>
        {erro && <p className={styles.error}>{erro}</p>}
        <Link to="/recuperar" className={styles.link}>Esqueceu sua senha?</Link>
      </form>
    </div>
  );
}

export default LoginPage;
